<template>
  <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_associated_plan')">
          <a-radio-group
            v-decorator="[
              'isPlan',
              {
                initialValue: 0,
                rules: [{ required: true, message: $t('page_material_warehousing_p_select') }]
              }
            ]"
            @change="changePlan"
          >
            <a-radio :value="1">
              {{ $t('yes') }}
            </a-radio>
            <a-radio :value="0">
              {{ $t('no') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_order_code')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'planCode',
              {
                rules: [
                  {
                    required: comformDefa.isPlan,
                    message: $t('page_material_warehousing_p_select')
                  }
                ]
              }
            ]"
            :disabled="!comformDefa.isPlan"
            showSearch
            :placeholder="$t('please_select') + $t('page_material_warehousing_order_code')"
            @change="handleChangePlan"
          >
            <template v-for="(item, index) in comformDefa.planList">
              <a-select-option :key="index" :value="item.code">
                {{ item.code }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_plan_order_no')">
          <a-select
            v-decorator="['planOrderCode']"
            show-search
            optionFilterProp="children"
            showSearch
            :placeholder="$t('please_select') + $t('page_plan_order_no')"
            @change="handleChangeOrder"
          >
            <template v-for="(item, index) in orderList">
              <a-select-option :key="index" :value="item.code">
                {{ item.code }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_product_process_no')">
          <a-select
            v-decorator="['processCode']"
            show-search
            optionFilterProp="children"
            showSearch
            :placeholder="$t('please_select') + $t('page_product_process_no')"
            @change="handleChangeProcess"
          >
            <template v-for="(item, index) in processList">
              <a-select-option :key="index" :value="item.processCode">
                {{ item.processCode }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_system_coding_rules')">
          <a-select
            style="width: 100%"
            show-search
            optionFilterProp="children"
            v-decorator="['codeRuleId']"
            :placeholder="$t('please_select') + $t('page_system_coding_rules')"
            :allowClear="true"
          >
            <a-select-option :value="item.value" v-for="(item, index) in codeList" :key="index">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_code')">
          <div>
            <a-input
              style="width: 100%"
              :disabled="codeRule != undefined"
              :placeholder="$t('common_please_input') + $t('page_material_warehousing_code')"
              v-decorator="['orderCode']"
            />
          </div>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_name')">
          <a-input
            style="width: 100%"
            v-decorator="['orderName', { max: 48 }]"
            :placeholder="$t('common_please_input') + $t('page_material_warehousing_name')"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_delivery_no')">
          {{ $t('page_material_warehousing_automatic') }}
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_feeding_ren')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['deliveryUser']"
            @change="handleSelectChange"
            :placeholder="$t('please_select') + $t('page_material_warehousing_feeding_ren')"
          >
            <a-select-option v-for="s in staff" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_code')">
          {{ $t('page_material_warehousing_automatic') }}
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_dept')">
          <a-tree-select
            v-decorator="['receivingDept']"
            :treeData="depts"
            tree-default-expand-all
            show-search
            tree-node-filter-prop="title"
            @change="handleReceivingDeptName"
            :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_dept')"
          >
          </a-tree-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_warehousing_receipt_ren')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="[
              'receivingUser',
              {
                rules: [{ required: true, message: $t('page_material_warehousing_p_select') }]
              }
            ]"
            :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_ren')"
            @change="handleReceivingUser"
          >
            <a-select-option v-for="s in staff" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('supplier')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['supplierId']"
            @change="handleSupplierName"
            :placeholder="$t('please_select') + $t('supplier')"
          >
            <a-select-option v-for="s in supplierList" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item :label="$t('page_material_ware_out_code')">
          <a-select
            show-search
            optionFilterProp="children"
            v-decorator="['outOrderCode']"
            :placeholder="$t('please_select') + $t('page_material_ware_out_code')"
            allowClear
            :disabled="comformDefa.isPlan"
            @change="(value) => handleChangeOutOrder(value)"
          >
            <a-select-option v-for="s in stockOutOrderList" :key="s.orderCode" :value="s.orderCode">
              {{ s.orderCode }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import {
  ProductionPlanServiceProxy,
  ProductionOrderServiceProxy
} from '@/service-proxies/app-v2/coproduction.service-proxies'

const posp = new ProductionOrderServiceProxy()
const ppsp = new ProductionPlanServiceProxy()
import form from './form.js'
export default {
  mixins: [form],
  data() {
    return {
      form: this.$form.createForm(this),
      codeList: [],
      supplierList: [],
      stockOutOrderList: [],
      deliveryUserName: '',
      receivingUserName: '',
      supplierName: '',
      orderList: [],
      processList: [],
      selectOrder: '',
      selectProcess: '',
      planListF: []
    }
  },
  props: {
    staff: {
      type: Array,
      default: () => []
    },
    depts: {
      type: Array,
      default: () => []
    },
    inTypeCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    inTypeCode: {
      handler() {
        this.reastAll()
      },
      deep: true,
      immediate: true
    },
    'comformDefa.selectPlan': {
      handler() {
        this.reastAll()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async reastAll() {
      this.form.setFieldsValue({
        processCode: '',
        planOrderCode: ''
      })
      this.selectOrder = ''
      this.selectProcess = ''
      const plan = this.comformDefa.planList.find((res) => res.code === this.comformDefa.selectPlan)
      if (plan) {
        posp.orderLis(plan.id).then((res) => {
          this.orderList = res
        })
      }
    },
    handleChangeOrder(value) {
      this.selectOrder = value
      const order = this.orderList.find((res) => res.code === value)
      if (order) {
        posp.processList(order.id).then((res) => {
          this.processList = res
        })
      }
    },
    handleChangeProcess(value) {
      this.selectProcess = value
    },
    getMaterialPlanList() {
      ppsp.productMaterials().then((res) => {
        this.comformDefa.planList = this.addCode(res)
      })
    },
    // 关联计划
    changePlan(value) {
      this.changeReast()
      this.comformDefa.selectPlan = ''
      if (value.target.value === 1) {
        this.comformDefa.isPlan = true
        this.stockOutOrderList = []
        this.getMaterialPlanList()
      } else {
        this.form.setFieldsValue({
          planCode: ''
        })
        this.planListF = []
        this.getStockOutOrder()
        this.comformDefa.isPlan = false
      }
      this.form.setFieldsValue({
        outOrderCode: ''
      })
      this.$emit('changDefa', this.comformDefa)
    },
    save(value, callback) {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.comformDefa.isPlan) {
            const plan = this.comformDefa.planList.find(
              (res) => res.code === this.comformDefa.selectPlan
            )
            values.planCode = this.comformDefa.selectPlan
            values.planId = plan ? plan.id : ''
            const order = this.orderList.find((res) => res.code === selectOrder)
            if (!order) {
              this.$message.warning(this.$t('page_material_ware_select_order'))
              return
            }
            const process = this.processList.find((res) => res.processCode === selectProcess)
            if (!process) {
              this.$message.warning(this.$t('page_material_ware_select_process'))
              return
            }
            values.planOrderCode = selectOrder
            values.planOrderId = order ? order.id : ''
            values.planOrderProcessCode = selectProcess
            values.planOrderProcessId = process ? process.id : ''
            values.planOrderProcessName = process ? process.processName : ''
          }
          const data = { ...values, ...value }
          callback(data)
        } else {
          callback(false)
        }
      })
    },
    handleChangePlan(value) {
      // this.changeReast()
      this.getMaterialPlanList()
      this.comformDefa.selectPlan = value
      if (this.comformDefa.selectPlan && this.inTypeCode) {
        this.stockOutOrderList = []
      } else {
        this.getStockOutOrder()
      }
      this.form.setFieldsValue({
        outOrderCode: ''
      })
      this.$emit('changDefa', this.comformDefa)
    }
  }
}
</script>
<style scoped></style>
